import React from 'react';
import Card from '../../common/Card/Card';
import { isHttpUrl } from '../../../utils/competitionCards';
import styles from './OverviewSections.module.css';

/**
 * Important Links & Resources. Every link opens in a new tab. A link without a
 * label, or whose URL is not plain http(s), is dropped; renders nothing when
 * none are left.
 */
const ImportantLinks = ({ links }) => {
  const items = (links || []).filter((l) => l && l.label && isHttpUrl(l.url));
  if (!items.length) return null;

  return (
    <Card title="Important Links & Resources">
      <div className={styles.links}>
        {items.map((link, i) => (
          <a
            key={`${link.url}-${i}`}
            className={styles.linkRow}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span>{link.label}</span>
            <span aria-hidden="true">↗</span>
          </a>
        ))}
      </div>
      <p className={styles.footnote}>
        Application portal, rules, CreatED guide and templates appear here when the team adds them.
      </p>
    </Card>
  );
};

export default ImportantLinks;
